import { init } from '@sentry/vue';
import { Options, TracingOptions, Vue } from '@sentry/vue/build/types/types';
import { useConfig } from './config';

export type SentryConfigOptions = Partial<
  Omit<Options, 'tracingOptions'> & {
    tracingOptions: Partial<TracingOptions>;
  }
> & {
  enabled?: boolean;
};

export const initSentry = (app?: Vue) => {
  const config = useConfig();
  const sentryConfig = config.value.sentry;

  if (!sentryConfig?.enabled) {
    return;
  }

  init({
    app,
    dsn: sentryConfig.dsn,
    environment: config.value.environment,
    release: `ewa-web-app@${import.meta.env.PACKAGE_VERSION}`,
    sampleRate: 1.0,
  });
};
